import React, { useContext, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


import { Editor } from '@tinymce/tinymce-react';

import authContext from '../../context/authContext/authContext';

import { useDispatch } from 'react-redux';
import { addProductAction } from '../../redux/actions/productsAction';
import Loader from '../../utils/Loader';
import RenderError from '../../utils/RenderError';

const initialState = {
  title: '',
  slogan: '',
  description: '',
  tokens: '',
  titleError: '',
  sloganError: '',
  descriptionError: '',
  tokensError: '',
  error: ''
};


const AddProduct = ({ isOpen, toggle, getProducts, parentId, loading }) => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext);
  const config = getConfig();

  const [state, setCompleteState] = useState(initialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }));

  const onHideModal = () => {
    setState(initialState)
    toggle();
  }

  const validateTitle = () => {
    if (!state.title.trim()) {
      setState({ titleError: '*Please enter product title' });
    }
  }

  const validateSlogan = () => {
    if (!state.slogan.trim()) {
      setState({ sloganError: '*Please enter product slogan' });
    }
  };


  const validateDescription = () => {
    if (!state.description.trim()) {
      setState({ descriptionError: '*Please enter description' });
    }
  };

  const validateTokens = () => {
    const { tokens } = state || {};
    if (tokens === '' || tokens === null || tokens === undefined) {
      setState({ tokensError: '*Please enter valid tokens' });
    }

    if (isNaN(tokens)) {
      setState({ tokensError: '*Tokens must be a number' });
    }
  };


  const addProduct = async () => {
    const { title, slogan, description, tokens } = state;
    if (!title || !slogan || !description) {
      setState({ error: '*Please fill all the required fields' });
      return;
    }

    const data = { title, slogan, description, tokens, parentId }
    if (parentId) {
      data.type = "subProduct"
    }

    dispatch(addProductAction(data, config, getProducts, onHideModal))
  }


  const handleSubmit = (e) => {
    e.preventDefault();
    addProduct();
  }

  const closeBtn = () => <button className='btn btn-close' onClick={onHideModal}>X</button>;

  return (
    <Modal isOpen={isOpen} toggle={onHideModal} size='lg'>
      <ModalHeader toggle={onHideModal} close={closeBtn()}>
        <div className='d-flex align-items-center'>
          <div>Add {parentId ? 'Sub' : ''}Product</div>
          <div className='ml-3'>
            <Loader isLoading={loading} />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div class="form-group">
            <label>Title</label>
            <input
              type="text"
              class="form-control"
              value={state?.title}
              onChange={(e) => setState({ title: e.target.value })}
              onFocus={() => setState({ titleError: '' })}
              onBlur={validateTitle}
              disabled={loading}
            />
            <RenderError error={state?.titleError} />
          </div>
          <div class="form-group">
            <label>Slogan</label>
            <input
              type="text"
              class="form-control"
              value={state?.slogan}
              onChange={(e) => setState({ slogan: e.target.value })}
              onFocus={() => setState({ sloganError: '' })}
              onBlur={validateSlogan}
              disabled={loading}
            />
            <RenderError error={state?.sloganError} />
          </div>
          <div class="form-group">
            <label>Description</label>
            <input
              type="text"
              class="form-control"
              value={state?.description}
              onChange={(e) => setState({ description: e.target.value })}
              onFocus={() => setState({ descriptionError: '' })}
              onBlur={validateDescription}
              disabled={loading}
            />
            <RenderError error={state?.descriptionError} />
          </div>
          <div class="form-group">
            <label>Tokens</label>
            <input
              type="number"
              class="form-control"
              min={0}
              value={state?.tokens}
              onChange={(e) => setState({ tokens: e.target.value })}
              onFocus={() => setState({ tokensError: '' })}
              onBlur={validateTokens}
              disabled={loading}
            />
            <RenderError error={state?.tokensError} />
          </div>
          <RenderError error={state?.error} />
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onHideModal} disabled={loading}>
          Cancel
        </Button>
        <Button color="gleamdesk-blue gleamdesk-orange" onClick={handleSubmit} disabled={loading}>
          Add Product
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AddProduct